import { ChatResponse, ResponseSuccess } from '../../TYPES/api.body';
import api from '../config/setAuthHeader';

export const getChatHistory = async (args: {
  nickname: string;
  userId: string;
}): Promise<ResponseSuccess<ChatResponse[]>> => {
  return api.get(`/messages/${args.nickname}/${args.userId}`);
};
